var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSuccess = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-30 -30)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#98c11d",
  d: "M58.738,44.67a1,1,0,0,0-1.479-1.346L47.075,54.511l-4.338-4.765a1,1,0,0,0-1.479,1.346l5.077,5.578a1,1,0,0,0,1.479,0Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#98c11d",
  d: "M50,33A17,17,0,1,0,67,50,17,17,0,0,0,50,33ZM35,50A15,15,0,1,1,50,65,15,15,0,0,1,35,50Z"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-success.53f12296.svg";
export { ForwardRef as ReactComponent };